// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
//引入element插件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

//引入图片上传插件
import ImgInputer from 'vue-img-inputer'
import 'vue-img-inputer/dist/index.css'
Vue.component('ImgInputer', ImgInputer)

//后台编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor, /* { default global options } */)

//meta
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

//文章详情分享插件
import Share from 'vue-social-share'
Vue.use(Share)
import 'vue-social-share/dist/client.css';

import storage from './storage/storage.js'
//引入iview
import iView from 'iview'; // 导入组件库
import 'iview/dist/styles/iview.css'; // 导入样式
Vue.use(iView, {
	transfer: true,
	size: 'default'
});

import 'jquery'
import vPage from 'v-page';
Vue.use(vPage);

import './static/css/index.css'
import './static/css/1024-2560.css'
import './static/css/lrtk.css'
import './static/css/icon.css'
import './static/js/count.js'


//swiper插件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

//请求数据插件引入
import router from './router'
import VueResource from 'vue-resource'
Vue.use(VueResource)

import Axios from 'axios'
import store from '@/vuex/store';

import './router/index.js'

// 裁剪插件cropper引入
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

//非父子传值公用
let bus = new Vue()
Vue.prototype.bus = bus


//登录option请求设置
Vue.http.options.emulateHTTP = true;
Vue.http.options.emulateJSON = true;
Vue.config.productionTip = false

Axios.defaults.headers.common['Authorization'] = store.state.token;
// 添加请求拦截器
Axios.interceptors.request.use(config => {
	// 在发送请求之前做些什么
	//判断是否存在token，如果存在将每个页面header都添加token
	if (store.state.token) {
		config.headers.common['Authorization'] = store.state.token
	}

	return config;
}, error => {
	// 对请求错误做些什么
	return Promise.reject(error);
});

import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video

/* eslint-disable no-new */

new Vue({
	el: '#app',
	// el: '#editorContainer',
	router,
	components: {
		App
	},
	render: h => h(App),
	/* 这句非常重要，否则预渲染将不会启动 */
	mounted() {
		document.dispatchEvent(new Event('render-event'))
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js